import {
  CButton,
  CCol,
  CInput,
  CLabel,
  CRow,
  CCardHeader,
  CSpinner,
  CForm,
  CInvalidFeedback,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
import Auth from "src/auth";
// import usersData from "../users/UsersData";
const AddCircleList = () => {
  const [loading, setloading] = useState(false);
  const [name, setname] = useState();
  const [discription, setdiscription] = useState();
  const [status, setstatus] = useState(false);
  const history = useHistory();
  const { authenticated } = Auth();
  const [disabledApproveRej, setdisabledApproveRej] = useState(false);

  const AddCircleListApi = async (e) => {
    e.preventDefault();
    setloading(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      `Circle_Master/add`,
      "POST",
      header,
      JSON.stringify({
        // circleId: circleid,
        name: name,
        desc: discription,
        status: status,
      })
    );

    if (response.status === 200) {
      history.push("/circlelist");
      await response.json();
    }
    setloading(false);
  };

  useEffect(() => {
    if (authenticated.role === "CGMF" && authenticated.isViewOnly) {
      setdisabledApproveRej(true);
    } else {
      setdisabledApproveRej(false);
    }
  }, [authenticated]);
  return (
    <>
      <CCardHeader className="mb-5">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Add Circle</h3>
          </CCol>
        </CRow>
        <hr />
        <CForm className="was-validation" onSubmit={AddCircleListApi}>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom01"
                className="col-sm-12 col-form-label"
              >
                Name:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                value={name}
                onChange={(e) => setname(e.target.value)}
                required
                id="validationCustom01"
                invalid={name === "" ? true : false}
              />
              <CInvalidFeedback className="validationCustom01">
                Please enter Name
              </CInvalidFeedback>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom02"
                className="col-sm-12 col-form-label"
              >
                Discription :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                value={discription}
                type="text"
                required
                id="validationCustom02"
                invalid={discription === "" ? true : false}
                onChange={(e) => setdiscription(e.target.value)}
              />
              <CInvalidFeedback className="validationCustom02">
                Please enter description
              </CInvalidFeedback>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Status:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <input
                placeholder=""
                type="checkbox"
                checked={status}
                onClick={() => {
                  setstatus(!status);
                }}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              {loading ? (
                <CSpinner className="spinner-grow" color="success" />
              ) : (
                <>
                  <CButton
                    className="ml-3"
                    disabled={disabledApproveRej}
                    color="success"
                    type="submit"
                  >
                    Save
                  </CButton>
                  <CButton
                    className="ml-3 "
                    color="success"
                    to={"/master/circlelist"}
                  >
                    Cancel
                  </CButton>
                </>
              )}
            </CCol>
          </CRow>
        </CForm>
      </CCardHeader>
    </>
  );
};
export default AddCircleList;
